import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import type { StyleBadge } from '../../types';

interface BadgeShowcaseProps {
  badges: StyleBadge[];
}

/**
 * BadgeShowcase — horizontal scrollable row of earned badges.
 * Unearned badges are shown dimmed.
 */
const BadgeShowcase: React.FC<BadgeShowcaseProps> = ({ badges }) => {
  if (badges.length === 0) return null;

  return (
    <Box sx={{
      display: 'flex', gap: 1, overflowX: 'auto', py: 0.5,
      '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none',
    }}>
      {badges.map((badge) => {
        const earned = !!badge.earnedAt;
        return (
          <Tooltip key={badge.id} title={`${badge.label}: ${badge.description}`}>
            <Box sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              opacity: earned ? 1 : 0.35, minWidth: 48, flexShrink: 0,
            }}>
              <Typography sx={{ fontSize: '1.5rem' }}>{badge.icon}</Typography>
              <Typography variant="caption" sx={{ fontSize: '0.55rem', textAlign: 'center', lineHeight: 1.1 }}>
                {badge.label}
              </Typography>
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default BadgeShowcase;
